import Vue from 'vue';
import Vuex from 'vuex';
import BackendService from '../services/BackendService';
import HouseholdAdult from '../types/HouseholdAdult';
import HouseholdChild from '../types/HouseholdChild';
import Attachment from '../types/Attachment';

Vue.use(Vuex);

function createAttachmentFromBackend(attachmentBackend) {
    const attachment = new Attachment();
    attachment.id = attachmentBackend.id;
    attachment.filename = attachmentBackend.filename;
    return attachment;
}

export default new Vuex.Store({
    state: {
        snackbars: [],
        loggedIn: false,
        step1: {
            complete: false,
            application: {
                shortDescription: null,
                requestReason: null,
            },
        },
        step2: {
            complete: false,
            applicant: {
                // read only
                initials: null,
                lastname: null,
                city: null,
                address: null,
                zipcode: null,
                phone: null,
                email: null,
                birthdate: null,
                // read/write
                gender: null,
                education: null,
                profession: null,
            },
        },
        step3: {
            complete: false,
            applicant: {
                householdAdultCount: 0,
                householdAdults: [],
                householdChildCount: 0,
                householdChildren: [],
            },
        },
        step4: {
            complete: false,
            applicant: {
                hasDebt: false,
                debtOverviews: [],
                hasDebtSettlement: false,
                hasSavings: false,
                savingsAmount: null,
                savingsReason: null,
                savingsStatements: [],
                bankStatements: [],
            },
        },
        step5: {
            complete: false,
            applicant: {
                hasCar: false,
                carLicensePlate: null,
                carReason: null,
                carRoadTaxAmount: null,
                carInsuranceAmount: null,
                carFuelAmount: null,
            },
        },
        step6: {
            complete: false,
            applicant: {
                income: {
                    welfareAmount: null,
                    salaryAmount: null,
                    studentGrantAmount: null,
                    alimonyAmount: null,
                    childRelatedBudgetAmount: null,
                    boardingWagesAmount: null,
                    housingAllowanceAmount: null,
                    healthAllowanceAmount: null,
                    personalBudgetAmount: null,
                    mortgageInterestAmount: null,
                    otherAmount: null,
                    pensionAmount: null,
                    specifications: [],
                },
                householdAdults: [],
            },
        },
        step7: {
            complete: false,
            applicant: {
                expense: {
                    rentMortgageAmount: null,
                    cityTaxAmount: null,
                    purificationChargesAmount: null,
                    utilitiesAmount: null,
                    waterAmount: null,
                    healthInsuranceAmount: null,
                    householdInsuranceAmount: null,
                    liabilityInsuranceAmount: null,
                    funeralInsuranceAmount: null,
                    internetTvPhoneAmount: null,
                    mobilePhoneAmount: null,
                    otherAmount: null,
                },
            },
        },
        step8: {
            complete: false,
            applicant: {
                requireEducationContract: false,
                requireHealthInsurancePolicy: false,
                requireMedicalConsent: false,
                requireQuotation: false,
                requireSocialSupportAct: false,
                requireSpecialWelfare: false,
                requireAnyDocument:true,
                documents: {
                    SPECIAL_WELFARE_CONTACT: [],
                    SOCIAL_SUPPORT_ACT: [],
                    MEDICAL_CONSENT: [],
                    EDUCATION_CONTRACT: [],
                    QUOTATION: [],
                    HEALTH_INSURANCE_POLICY: [],
                }
            },
        },
        step9: {
            complete: false,
            application: {
                enteredTruthfully: null,
                privacyConsent: null,
            },
        },
        finish: {
            complete: false,
            submitted: null,
        },
    },
    mutations: {
        SNACKBAR_ADDED(state, payload) {
            state.snackbars.push(payload);
        },
        SNACKBAR_REMOVE_TOP(state) {
            state.snackbars.shift();
        },
        LOGGED_IN(state, payload) {
            state.loggedIn = true;
            BackendService.setToken(payload.data.token);
        },
        LOGGED_OUT(state) {
            BackendService.setToken('');
            state.loggedIn = false;
        },
        STEP1_UPDATE(state, payload) {
            state.step1.application.shortDescription = payload.application.shortDescription;
            state.step1.application.requestReason = payload.application.requestReason;
            state.step1.complete = payload.complete;
        },
        STEP2_UPDATE(state, payload) {
            // read only
            state.step2.applicant.initials = payload.applicant.initials;
            state.step2.applicant.lastname = payload.applicant.lastname;
            state.step2.applicant.city = payload.applicant.city;
            state.step2.applicant.address = payload.applicant.address;
            state.step2.applicant.zipcode = payload.applicant.zipcode;
            state.step2.applicant.phone = payload.applicant.phone;
            state.step2.applicant.email = payload.applicant.email;
            state.step2.applicant.birthdate = payload.applicant.birthdate;

            // read/write
            state.step2.applicant.gender = payload.applicant.gender;
            state.step2.applicant.education = payload.applicant.education;
            state.step2.applicant.profession = payload.applicant.profession;
            state.step2.complete = payload.complete;
        },
        STEP3_UPDATE(state, payload) {
            state.step3.applicant.householdAdultCount = payload.applicant.householdAdultCount;
            for (let idx = 0; idx < payload.applicant.householdAdults.length; idx++) {
                const payloadAdult = payload.applicant.householdAdults[idx];
                let stateAdult;
                if (state.step3.applicant.householdAdults.length > idx) {
                    stateAdult = state.step3.applicant.householdAdults[idx];
                } else {
                    stateAdult = new HouseholdAdult(idx + 1);
                    state.step3.applicant.householdAdults.push(stateAdult);
                }
                if (idx < state.step3.applicant.householdAdultCount) {
                    stateAdult.show = true;
                }
                stateAdult.gender = payloadAdult.gender;
                stateAdult.name = payloadAdult.name;
                stateAdult.birthdate = payloadAdult.birthdate;
            }
            state.step3.applicant.householdChildCount = payload.applicant.householdChildCount;
            state.step3.applicant.householdChildren=[];
            for (let idx = 0; idx < payload.applicant.householdChildren.length; idx++) {
                const payloadChild = payload.applicant.householdChildren[idx];
                let stateChild;
                if (state.step3.applicant.householdChildren.length > idx) {
                    stateChild = state.step3.applicant.householdChildren[idx];
                } else {
                    stateChild = new HouseholdChild(idx + 1);
                    state.step3.applicant.householdChildren.push(stateChild);
                }
                if (idx < state.step3.applicant.householdChildCount) {
                    stateChild.show = true;
                }
                stateChild.gender = payloadChild.gender;
                stateChild.name = payloadChild.name;
                stateChild.birthdate = payloadChild.birthdate;
            }
            state.step3.complete = payload.complete;
        },
        STEP4_UPDATE(state, payload) {
            state.step4.applicant.hasDebt = payload.applicant.hasDebt;
            state.step4.applicant.debtOverviews = payload.applicant.debtOverviews.map(createAttachmentFromBackend);
            state.step4.applicant.hasDebtSettlement = payload.applicant.hasDebtSettlement;
            state.step4.applicant.hasSavings = payload.applicant.hasSavings;
            state.step4.applicant.savingsAmount = payload.applicant.savingsAmount;
            state.step4.applicant.savingsReason = payload.applicant.savingsReason;
            state.step4.applicant.savingsStatements = payload.applicant.savingsStatements.map(
                createAttachmentFromBackend
            );
            state.step4.applicant.bankStatements = payload.applicant.bankStatements.map(createAttachmentFromBackend);
            state.step4.complete = payload.complete;
        },
        STEP5_UPDATE(state, payload) {
            state.step5.applicant.hasCar = payload.applicant.hasCar;
            state.step5.applicant.carLicensePlate = payload.applicant.carLicensePlate;
            state.step5.applicant.carReason = payload.applicant.carReason;
            state.step5.applicant.carRoadTaxAmount = payload.applicant.carRoadTaxAmount;
            state.step5.applicant.carInsuranceAmount = payload.applicant.carInsuranceAmount;
            state.step5.applicant.carFuelAmount = payload.applicant.carFuelAmount;
            state.step5.complete = payload.complete;
        },
        STEP6_UPDATE(state, payload) {
            state.step6.applicant.income.welfareAmount = payload.applicant.income.welfareAmount;
            state.step6.applicant.income.salaryAmount = payload.applicant.income.salaryAmount;
            state.step6.applicant.income.studentGrantAmount = payload.applicant.income.studentGrantAmount;
            state.step6.applicant.income.alimonyAmount = payload.applicant.income.alimonyAmount;
            state.step6.applicant.income.childRelatedBudgetAmount = payload.applicant.income.childRelatedBudgetAmount;
            state.step6.applicant.income.boardingWagesAmount = payload.applicant.income.boardingWagesAmount;
            state.step6.applicant.income.housingAllowanceAmount = payload.applicant.income.housingAllowanceAmount;
            state.step6.applicant.income.healthAllowanceAmount = payload.applicant.income.healthAllowanceAmount;
            state.step6.applicant.income.personalBudgetAmount = payload.applicant.income.personalBudgetAmount;
            state.step6.applicant.income.mortgageInterestAmount = payload.applicant.income.mortgageInterestAmount;
            state.step6.applicant.income.otherAmount = payload.applicant.income.otherAmount;
            state.step6.applicant.income.pensionAmount = payload.applicant.income.pensionAmount;
            state.step6.applicant.income.specifications = payload.applicant.income.specifications.map(
                createAttachmentFromBackend
            );
            // household adults
            state.step6.applicant.householdAdults.forEach(householdAdult => (householdAdult.show = false));
            for (let idx = 0; idx < payload.applicant.householdAdults.length; idx++) {
                const payloadAdult = payload.applicant.householdAdults[idx];
                let stateAdult;
                if (state.step6.applicant.householdAdults.length > idx) {
                    stateAdult = state.step6.applicant.householdAdults[idx];
                } else {
                    stateAdult = new HouseholdAdult(null);
                    state.step6.applicant.householdAdults.push(stateAdult);
                }
                stateAdult.id = payloadAdult.id;
                stateAdult.show = true;
                stateAdult.name = payloadAdult.name;
                stateAdult.income.welfareAmount = payloadAdult.income.welfareAmount;
                stateAdult.income.salaryAmount = payloadAdult.income.salaryAmount;
                stateAdult.income.studentGrantAmount = payloadAdult.income.studentGrantAmount;
                stateAdult.income.alimonyAmount = payloadAdult.income.alimonyAmount;
                stateAdult.income.childRelatedBudgetAmount = payloadAdult.income.childRelatedBudgetAmount;
                stateAdult.income.boardingWagesAmount = payloadAdult.income.boardingWagesAmount;
                stateAdult.income.housingAllowanceAmount = payloadAdult.income.housingAllowanceAmount;
                stateAdult.income.healthAllowanceAmount = payloadAdult.income.healthAllowanceAmount;
                stateAdult.income.personalBudgetAmount = payloadAdult.income.personalBudgetAmount;
                stateAdult.income.mortgageInterestAmount = payloadAdult.income.mortgageInterestAmount;
                stateAdult.income.otherAmount = payloadAdult.income.otherAmount;
                stateAdult.income.pensionAmount = payloadAdult.income.pensionAmount;
                stateAdult.income.specifications = payloadAdult.income.specifications.map(createAttachmentFromBackend);
            }
            state.step6.complete = payload.complete;
        },
        STEP7_UPDATE(state, payload) {
            state.step7.applicant.expense.rentMortgageAmount = payload.applicant.expense.rentMortgageAmount;
            state.step7.applicant.expense.cityTaxAmount = payload.applicant.expense.cityTaxAmount;
            state.step7.applicant.expense.purificationChargesAmount =
                payload.applicant.expense.purificationChargesAmount;
            state.step7.applicant.expense.utilitiesAmount = payload.applicant.expense.utilitiesAmount;
            state.step7.applicant.expense.waterAmount = payload.applicant.expense.waterAmount;
            state.step7.applicant.expense.healthInsuranceAmount = payload.applicant.expense.healthInsuranceAmount;
            state.step7.applicant.expense.householdInsuranceAmount = payload.applicant.expense.householdInsuranceAmount;
            state.step7.applicant.expense.liabilityInsuranceAmount = payload.applicant.expense.liabilityInsuranceAmount;
            state.step7.applicant.expense.funeralInsuranceAmount = payload.applicant.expense.funeralInsuranceAmount;
            state.step7.applicant.expense.internetTvPhoneAmount = payload.applicant.expense.internetTvPhoneAmount;
            state.step7.applicant.expense.mobilePhoneAmount = payload.applicant.expense.mobilePhoneAmount;
            state.step7.applicant.expense.otherAmount = payload.applicant.expense.otherAmount;
            state.step7.complete = payload.complete;
        },
        STEP8_UPDATE(state, payload) {
            state.step8.applicant.requireEducationContract = payload.applicant.requireEducationContract;
            state.step8.applicant.requireHealthInsurancePolicy = payload.applicant.requireHealthInsurancePolicy;
            state.step8.applicant.requireMedicalConsent = payload.applicant.requireMedicalConsent;
            state.step8.applicant.requireQuotation = payload.applicant.requireQuotation;
            state.step8.applicant.requireSocialSupportAct = payload.applicant.requireSocialSupportAct;
            state.step8.applicant.requireSpecialWelfare = payload.applicant.requireSpecialWelfare;
            state.step8.applicant.requireAnyDocument = payload.applicant.requireAnyDocument;
            state.step8.applicant.documents.SPECIAL_WELFARE_CONTACT = payload.applicant.documents.SPECIAL_WELFARE_CONTACT.map(createAttachmentFromBackend);
            state.step8.applicant.documents.SOCIAL_SUPPORT_ACT = payload.applicant.documents.SOCIAL_SUPPORT_ACT.map(createAttachmentFromBackend);
            state.step8.applicant.documents.MEDICAL_CONSENT = payload.applicant.documents.MEDICAL_CONSENT.map(createAttachmentFromBackend);
            state.step8.applicant.documents.EDUCATION_CONTRACT = payload.applicant.documents.EDUCATION_CONTRACT.map(createAttachmentFromBackend);
            state.step8.applicant.documents.QUOTATION = payload.applicant.documents.QUOTATION.map(createAttachmentFromBackend);
            state.step8.applicant.documents.HEALTH_INSURANCE_POLICY = payload.applicant.documents.HEALTH_INSURANCE_POLICY.map(createAttachmentFromBackend);

            // state.step8.applicant.specialWelfareContacts = payload.applicant.specialWelfareContacts.map(
            //     createAttachmentFromBackend
            // );
            // state.step8.applicant.healthInsurancePolicies = payload.applicant.healthInsurancePolicies.map(
            //     createAttachmentFromBackend
            // );
            state.step8.complete = payload.complete;
        },
        STEP9_UPDATE(state, payload) {
            state.step9.application.enteredTruthfully = payload.application.enteredTruthfully;
            state.step9.application.privacyConsent = payload.application.privacyConsent;
            state.step9.complete = payload.complete;
        },
        FINISH_UPDATE(state, payload) {
            state.finish.complete = payload.complete;
            state.finish.submitted = payload.submitted;
        },
    },
    actions: {
        addSnackbar({ commit }, payload) {
            const snackbar = {
                message: payload,
            };
            commit('SNACKBAR_ADDED', snackbar);
        },
        removeTopSnackbar({ commit }) {
            commit('SNACKBAR_REMOVE_TOP');
        },
        async login({ commit }, payload) {
            const response = await BackendService.login(payload.application.uniqueToken, {
                applicant: payload.applicant,
            });
            commit('LOGGED_IN', response.data);
        },
        logout({ commit }) {
            commit('LOGGED_OUT');
            // removes all state from session
            location.assign('/');
        },
        async step1Load({ commit }) {
            const response = await BackendService.step1Load();
            commit('STEP1_UPDATE', response.data.data);
        },
        async step1Submit({ commit }, payload) {
            const response = await BackendService.step1Submit(payload);
            commit('STEP1_UPDATE', response.data.data);
        },
        async step2Load({ commit }) {
            const response = await BackendService.step2Load();
            commit('STEP2_UPDATE', response.data.data);
        },
        async step2Submit({ commit }, payload) {
            const response = await BackendService.step2Submit(payload);
            commit('STEP2_UPDATE', response.data.data);
        },
        async step3Load({ commit }) {
            const response = await BackendService.step3Load();
            commit('STEP3_UPDATE', response.data.data);
        },
        async step3Submit({ commit }, payload) {
            const response = await BackendService.step3Submit(payload);
            commit('STEP3_UPDATE', response.data.data);
        },
        async step4Load({ commit }) {
            const response = await BackendService.step4Load();
            commit('STEP4_UPDATE', response.data.data);
        },
        async step4Submit({ commit }, payload) {
            const response = await BackendService.step4Submit(payload);
            commit('STEP4_UPDATE', response.data.data);
        },
        async step5Load({ commit }) {
            const response = await BackendService.step5Load();
            commit('STEP5_UPDATE', response.data.data);
        },
        async step5Submit({ commit }, payload) {
            const response = await BackendService.step5Submit(payload);
            commit('STEP5_UPDATE', response.data.data);
        },
        async step6Load({ commit }) {
            const response = await BackendService.step6Load();
            commit('STEP6_UPDATE', response.data.data);
        },
        async step6Submit({ commit }, payload) {
            const response = await BackendService.step6Submit(payload);
            commit('STEP6_UPDATE', response.data.data);
        },
        async step7Load({ commit }) {
            const response = await BackendService.step7Load();
            commit('STEP7_UPDATE', response.data.data);
        },
        async step7Submit({ commit }, payload) {
            const response = await BackendService.step7Submit(payload);
            commit('STEP7_UPDATE', response.data.data);
        },
        async step8Load({ commit }) {
            const response = await BackendService.step8Load();
            commit('STEP8_UPDATE', response.data.data);
        },
        async step8Submit({ commit }, payload) {
            const response = await BackendService.step8Submit(payload);
            commit('STEP8_UPDATE', response.data.data);
        },
        async step9Load({ commit }) {
            const response = await BackendService.step9Load();
            commit('STEP9_UPDATE', response.data.data);
        },
        async step9Submit({ commit }, payload) {
            const response = await BackendService.step9Submit(payload);
            commit('STEP9_UPDATE', response.data.data);
        },
        async finishLoad({ commit }) {
            const response = await BackendService.finishLoad();
            commit('FINISH_UPDATE', response.data.data);
        },
        async finishSubmit({ commit }, payload) {
            const response = await BackendService.finishSubmit(payload);
            commit('FINISH_UPDATE', response.data.data);
        },
    },
    getters: {
        snackbars(state) {
            return state.snackbars;
        },
        stepsComplete(state) {
            return {
                step1: state.step1.complete,
                step2: state.step2.complete,
                step3: state.step3.complete,
                step4: state.step4.complete,
                step5: state.step5.complete,
                step6: state.step6.complete,
                step7: state.step7.complete,
                step8: state.step8.complete,
                step9: state.step9.complete,
            };
        },
        step1(state) {
            return state.step1;
        },
        step2(state) {
            return state.step2;
        },
        step3(state) {
            return state.step3;
        },
        step4(state) {
            return state.step4;
        },
        step5(state) {
            return state.step5;
        },
        step6(state) {
            return state.step6;
        },
        step7(state) {
            return state.step7;
        },
        step8(state) {
            return state.step8;
        },
        step9(state) {
            return state.step9;
        },
        finish(state) {
            return state.finish;
        },
    },
    modules: {},
});
